'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Paginator = undefined;

var _Paginator2 = require('./Paginator');

var _Paginator3 = _interopRequireDefault(_Paginator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Paginator = _Paginator3.default; /**
                                          * Created by maximus on 08.11.16.
                                          */


//////////////////
// WEBPACK FOOTER
// ./src/components/Paginator/index.js
// module id = 1718
// module chunks = 0